"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationListMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class PaginationListMixin */
/** @method */
var PaginationListMixin = function PaginationListMixin(props) {
  return (0, _styledToken.default)({
    margin: 'PaginationList.margin',
    padding: 'PaginationList.padding',
    alignItems: 'PaginationList.alignItems'
  }, function (_ref) {
    var _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems;
    return (0, _styledComponents.css)(["margin:", ";padding:", ";list-style-type:none;display:flex;flex-flow:row;align-items:", ";"], margin, padding, alignItems);
  })(props);
};
exports.PaginationListMixin = PaginationListMixin;